import { render, staticRenderFns } from "./index.vue?vue&type=template&id=cba19312&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=cba19312&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cba19312",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\project\\huixin\\云商\\V12_saas版\\erp-flexible-web21-cloud-saas\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('cba19312')) {
      api.createRecord('cba19312', component.options)
    } else {
      api.reload('cba19312', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=cba19312&scoped=true", function () {
      api.rerender('cba19312', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Form/index.vue"
export default component.exports